import React, { FC } from 'react';
import { TFeatureHeaderProps } from '../types/productSeriesDetailFeature.types';
import TextComponentDecider from '../../@shared/TextComponentDecider';
import { getTextType } from '../../../utils/getTextType.utils';

const FeatureHeader: FC<TFeatureHeaderProps> = (props) => {
  const { title, titleKeySeriesFeature } = props;
  return (
    <div className="series-details__header">
      <TextComponentDecider
        type={getTextType('Text', !title)}
        tag={'h2'}
        field={{ value: title }}
        className="series-details__title"
        dictionaryKey={titleKeySeriesFeature}
      />
    </div>
  );
};

export default FeatureHeader;
